import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import styles from './styles.module.scss';
import clsx from 'clsx';

type Props = Omit<BaseButtonProps, 'isSelected'> & {
    isSelected?: boolean;
};

export const SecondaryFloorButton = ({ children, isSelected = false, ...props }: Props) => {
    return (
        <BaseButton
            {...props}
            className={clsx(styles['secondary-floor-button'], {
                [styles['secondary-floor-button--selected']]: isSelected,
            })}
        >
            <span>{children}</span>
        </BaseButton>
    );
};
